import { FETCH_PEDIDOS_COLORES,FETCH_PEDIDOS_USO,FETCH_PROFORMA_COLOR,SAVE_PEDIDOS_COLOR,SAVE_PEDIDOS_USO,DELETE_PEDIDOS_COLORES,FETCH_VALIDAR_PROFORMA ,FVTA_WEL_PACK_PROF_VEH,FETCH_FVTA_WEL_PACK_PROF_VEH,REG_FVTA_WEL_PACK_PROF_VEH} from '../actions';

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_PEDIDOS_COLORES:
      return action.payload.data;
    case FETCH_PEDIDOS_USO:
      return action.payload.data;
    case FETCH_PROFORMA_COLOR:
      return action.payload.data;
    case SAVE_PEDIDOS_COLOR:
      return action.payload.data;
    case SAVE_PEDIDOS_USO:
      return action.payload.data;
    case DELETE_PEDIDOS_COLORES:
      return action.payload.data;
    case FETCH_VALIDAR_PROFORMA:
        return action.payload.data;// Req 93426 ebarboza 29 11 2021
    case FVTA_WEL_PACK_PROF_VEH:
        return !action.payload.data ? [] : action.payload.data;// Req 93426 ebarboza 29 11 2021
    case FETCH_FVTA_WEL_PACK_PROF_VEH:
        return !action.payload.data ? [] : action.payload.data;// Req 93426 ebarboza 29 11 2021
    case REG_FVTA_WEL_PACK_PROF_VEH:
        return !action.payload.data ? [] : action.payload.data;// Req 93426 ebarboza 29 11 2021
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/PedidosColores.js